import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { stopPropagation } from '../../../../utils/events'
import { Accordion, AccordionItem } from '../../../Accordion'
import { FLAT_FORM_FIELD_NAME_CONTRACTS } from '../FlatForm.constants'

import { Fields } from './Fields'
import { QA_NAME_FLAT_FORM_INHABITANT } from './FlatFormInhabitantFields.constants'

import * as styles from './FlatFormInhabitantFields.module.css'

function FlatFormInhabitantFields({ disabled, onRemove }) {
  const { t } = useTranslation()

  const { values } = useFormikContext()

  function handleDelete(event, index) {
    if (!disabled) {
      stopPropagation(event)

      onRemove(index)
    }
  }

  function getHandleDelete(index) {
    return event => handleDelete(event, index)
  }

  return (
    <div>
      <Accordion
        singleColumn
        disabled={disabled}
        itemClassName={styles.accordionItem}
        variant='style1'
      >
        {values?.[FLAT_FORM_FIELD_NAME_CONTRACTS].map((contract, index) => (
          <AccordionItem
            initOpen
            accordionTitle={`${t('Flat.InhabitantBtnKey')} ${index + 1}`}
            key={index}
            qaName={`${QA_NAME_FLAT_FORM_INHABITANT}_${index + 1}`}
            onDelete={getHandleDelete(index)}
          >
            <Fields index={index} />
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  )
}

export default FlatFormInhabitantFields
